import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LiveBusMapLayer from "../components/LiveBusMapLayer";

const LiveBusMapPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Live Bus Map" />
      <LiveBusMapLayer />
    </MasterLayout>
  );
};

export default LiveBusMapPage;
